/* ============================================================
   EAU DE LABEL — Luxury Shopify Theme
   theme.js  |  Version 3.0 — HTML-faithful rebuild
   ============================================================ */

'use strict';

/* ─────────────────────────────────────────────────────────────
   SHOPIFY.FORMATMONEY POLYFILL
   Shopify injects this global in production. In theme preview
   or local dev it may be absent, causing cart to show
   "Unable to load bag." This lightweight fallback uses the
   store's money_format string (e.g. "R {{amount}}").
   ───────────────────────────────────────────────────────────── */
if (!window.Shopify) window.Shopify = {};
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents) {
    if (cents == null || isNaN(cents)) return '';
    var fmt = (Shopify.money_format || 'R {{amount}}');
    var amount = (parseFloat(cents) / 100)
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace('{{amount}}', amount)
              .replace('{{amount_no_decimals}}', Math.round(parseFloat(cents) / 100))
              .replace('{{amount_with_comma_separator}}', amount.replace(',', '.').replace('.', ','));
  };
}

var EDL = window.EDL || {};

/* ─────────────────────────────────────────────────────────────
   UTILS
   ───────────────────────────────────────────────────────────── */
var lerp = function(a, b, t) { return a + (b - a) * t; };
var isTouch = function() { return window.matchMedia('(hover: none)').matches; };
var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;


/* ─────────────────────────────────────────────────────────────
   PAGE LOADER  (class states: content-in → lifting → gone)
   ───────────────────────────────────────────────────────────── */
(function() {
  var loader = document.getElementById('page-loader');
  if (!loader) return;

  if (reducedMotion) {
    loader.classList.add('gone');
    return;
  }

  var isFirstVisit = !sessionStorage.getItem('edl_visited');
  if (isFirstVisit) sessionStorage.setItem('edl_visited', '1');
  var hold = isFirstVisit ? 2200 : 1100;

  requestAnimationFrame(function() { loader.classList.add('content-in'); });

  setTimeout(function() {
    loader.classList.add('lifting');
    setTimeout(function() { loader.classList.add('gone'); }, 1200);
  }, hold);
})();


/* ─────────────────────────────────────────────────────────────
   EXIT CURTAIN  (class: closing)
   ───────────────────────────────────────────────────────────── */
(function() {
  var curtain  = document.getElementById('exit-curtain');
  var isClosing = false;

  // navigateTo — shared helper used by the curtain AND the
  // product-card click handler so all navigation is consistent.
  window.EDLNavigate = function(href) {
    if (!href || href === '#') return;
    if (isClosing) { window.location.href = href; return; }
    if (curtain && !reducedMotion) {
      isClosing = true;
      curtain.classList.add('closing');
      setTimeout(function() { window.location.href = href; }, 580);
    } else {
      window.location.href = href;
    }
  };

  if (!curtain || reducedMotion) return;

  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href === '#' || href.startsWith('http') ||
        href.startsWith('mailto:') || href.startsWith('tel:') ||
        href.startsWith('/checkout') || href.includes('checkout') ||
        link.target === '_blank') return;
    e.preventDefault();
    window.EDLNavigate(href);
  });
})();


/* ─────────────────────────────────────────────────────────────
   SCROLL REVEAL  (.reveal → .in-view on intersection)
   ───────────────────────────────────────────────────────────── */
(function() {
  var els = document.querySelectorAll('.reveal');
  if (!els.length || !('IntersectionObserver' in window)) {
    els.forEach(function(el) { el.classList.add('in-view'); });
    return;
  }
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -20px 0px' });
  els.forEach(function(el) { obs.observe(el); });
})();


/* ─────────────────────────────────────────────────────────────
   HERO CINEMATIC REVEAL
   Sequence: loader lifts → eyebrow → words stagger → sub →
             cta → scroll indicator → bg text → bottle rise
   ───────────────────────────────────────────────────────────── */
(function() {
  var heroEye    = document.querySelector('.hero-eyebrow');
  var heroWords  = document.querySelectorAll('.hero-word');
  var heroSub    = document.querySelector('.hero-sub');
  var heroCta    = document.querySelector('.hero-cta-row');
  var heroScroll = document.querySelector('.hero-scroll');
  var heroBgText = document.querySelector('.hero-bg-text');
  var heroBottle = document.querySelector('.hero-bottle');

  // Only run on pages that have a hero
  if (!heroEye && !heroWords.length) return;

  function applyReveal(el, delay, props) {
    if (!el) return;
    setTimeout(function() {
      el.style.transition = 'opacity 0.75s cubic-bezier(0.25,0.46,0.45,0.94), transform 0.75s cubic-bezier(0.25,0.46,0.45,0.94)';
      for (var p in props) { el.style[p] = props[p]; }
    }, delay);
  }

  // Bottle float animation (sine wave after reveal)
  // Pauses automatically when the browser tab is hidden to save CPU/GPU.
  var bottleStarted = false;
  var bottleRafId   = null;
  var bottleT       = 0;
  function bottleTick() {
    bottleT += 0.007;
    var y   = Math.sin(bottleT) * 9;
    var rot = Math.sin(bottleT * 0.65) * 1.1;
    heroBottle.style.transform = 'translateY(calc(-50% + ' + y + 'px)) rotate(' + rot + 'deg)';
    heroBottle.style.transition = 'none';
    bottleRafId = requestAnimationFrame(bottleTick);
  }
  document.addEventListener('visibilitychange', function() {
    if (!bottleStarted || !heroBottle) return;
    if (document.hidden) {
      cancelAnimationFrame(bottleRafId);
    } else {
      bottleRafId = requestAnimationFrame(bottleTick);
    }
  });
  function startBottleFloat() {
    if (bottleStarted || !heroBottle) return;
    bottleStarted = true;
    bottleRafId = requestAnimationFrame(bottleTick);
  }

  function revealHero() {
    if (reducedMotion) {
      [heroEye, heroSub, heroCta, heroScroll, heroBgText].forEach(function(el) {
        if (el) { el.style.opacity = '1'; el.style.transform = 'none'; }
      });
      heroWords.forEach(function(w) { w.style.opacity = '1'; w.style.transform = 'none'; });
      if (heroBottle) { heroBottle.style.opacity = '0.18'; heroBottle.style.transform = 'translateY(-50%)'; }
      return;
    }

    // 1 — eyebrow label
    applyReveal(heroEye, 0, { opacity: '1', transform: 'translateY(0)' });

    // 2 — headline words, staggered
    heroWords.forEach(function(word, i) {
      applyReveal(word, 120 + i * 105, { opacity: '1', transform: 'translateY(0)' });
    });

    // 3 — subtext, CTA, scroll after all words
    var wordsDone = 120 + heroWords.length * 105;
    applyReveal(heroSub,    wordsDone + 80,  { opacity: '1', transform: 'translateY(0)' });
    applyReveal(heroCta,    wordsDone + 220, { opacity: '1', transform: 'translateY(0)' });
    applyReveal(heroScroll, wordsDone + 420, { opacity: '1' });

    // 4 — background text (slow atmospheric fade)
    setTimeout(function() {
      if (heroBgText) {
        heroBgText.style.transition = 'opacity 2.5s ease';
        heroBgText.style.opacity = '1';
      }
    }, 300);

    // 5 — bottle rises from below, then floats
    setTimeout(function() {
      if (heroBottle) {
        heroBottle.style.transition = 'opacity 1.4s cubic-bezier(0.25,0.46,0.45,0.94), transform 1.6s cubic-bezier(0.25,0.46,0.45,0.94)';
        heroBottle.style.opacity = '0.18';
        heroBottle.style.transform = 'translateY(-50%)';
        setTimeout(startBottleFloat, 1800);
      }
    }, 400);
  }

  // Hero parallax — bg text drifts upward on scroll
  // Uses a rAF-gated ticking flag so DOM writes happen at most once per frame,
  // preventing style recalculations from outpacing the display refresh rate.
  if (!isTouch() && !reducedMotion && heroBgText) {
    var parallaxTicking = false;
    window.addEventListener('scroll', function() {
      if (!parallaxTicking) {
        requestAnimationFrame(function() {
          heroBgText.style.transform = 'translateY(' + (window.scrollY * 0.22) + 'px)';
          parallaxTicking = false;
        });
        parallaxTicking = true;
      }
    }, { passive: true });
  }

  // Run after the same hold duration as the page loader
  var isFirstVisit = !sessionStorage.getItem('edl_visited');
  var hold = isFirstVisit ? 1350 : 700;
  setTimeout(revealHero, hold);
})();


/* ─────────────────────────────────────────────────────────────
   PRODUCT CARDS — mousemove 3D tilt (non-featured-collection cards only)
   Featured-collection cards (.products context) use the editorial expansion
   JS below; their 3D tilt is handled entirely by CSS on hover.
   ───────────────────────────────────────────────────────────── */
(function() {
  var cards = document.querySelectorAll('.product-card');
  if (!cards.length) return;

  cards.forEach(function(card) {
    var wrap = card.querySelector('.product-image-wrap');
    if (!wrap) return;

    // Featured-collection cards: no JS tilt — CSS handles it on :hover
    if (card.closest('.products')) return;

    // All other product cards (collection grid, search, etc.):
    // click image wrap → navigate via exit curtain
    var href = card.dataset.productHref;
    if (href) {
      wrap.addEventListener('click', function(e) {
        if (e.target.closest('a[href]')) return;
        e.preventDefault();
        window.EDLNavigate(href);
      });
    }

    // Mouse-tracking 3D tilt (desktop only)
    if (isTouch() || reducedMotion) return;
    card.addEventListener('mousemove', function(e) {
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width  - 0.5;
      var y = (e.clientY - r.top)  / r.height - 0.5;
      wrap.style.transform = 'scale(1.018) rotateY(' + (x * 4) + 'deg) rotateX(' + (-y * 2.5) + 'deg)';
      wrap.style.transition = 'transform 0.1s ease';
    });
    card.addEventListener('mouseleave', function() {
      wrap.style.transform = '';
      wrap.style.transition = 'transform 0.7s cubic-bezier(0.25,0.46,0.45,0.94)';
    });
  });
})();


/* ─────────────────────────────────────────────────────────────
   COLLECTION SHOWCASE PARALLAX
   Full-screen sticky sections; scroll-driven layer movement.

   Layers keyed by data-plx="":
     0  → fc-letter  (bg glyph)     slow vertical drift
     1  → image col                 medium vertical lift
     img → fc-product-img / fc-tee-art  zoom-reveal (scale+translateY)
     1a → coming-soon badge         slight counter-drift
     2  → meta + name               slide in from right, early
     3  → highlight + short + story slide in from right, delayed
     4  → notes + cta               slide in from right, most delayed

   Image zoom-reveal (inspired by parallax+zoom scroll pattern):
     The .fc-image-frame has overflow:hidden. The inner image starts
     at scale(1.16) translateY(62px) and resolves to scale(1.0)
     translateY(0) as p goes 0 → 0.28. After that the column's own
     vertical drift (layer 1) carries the image upward naturally.
   ───────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  // Respect reduced-motion preference
  var prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Touch / small-screen: skip (mobile uses static layout)
  function isMobileLayout() { return window.innerWidth <= 860; }

  // Linear interpolation helper
  function lerp(a, b, t) { return a + (b - a) * t; }

  // Clamp
  function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }

  // Ease-out curve — decelerates into final position
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

  // Stronger ease specifically for the image reveal (more cinematic decel)
  function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }

  // Per-variant state
  var variants = [];

  function collectVariants() {
    variants = [];
    var els = document.querySelectorAll('[data-fc-variant]');
    els.forEach(function (variant) {
      var scene = variant.querySelector('[data-fc-scene]');
      if (!scene) return;

      // Inner image element — either a real <img> or the SVG tee-art wrapper
      var imgInner = scene.querySelector('.fc-product-img') ||
                     scene.querySelector('.fc-tee-art');

      variants.push({
        variant  : variant,
        scene    : scene,
        // Parallax layers
        letter   : scene.querySelector('[data-plx="0"]'),
        imgCol   : scene.querySelector('[data-plx="1"]'),
        imgInner : imgInner,                              // ← zoom-reveal target
        priceBdg : scene.querySelector('[data-plx="1a"]'),
        name     : scene.querySelectorAll('[data-plx="2"]'),
        l3       : scene.querySelectorAll('[data-plx="3"]'),
        l4       : scene.querySelectorAll('[data-plx="4"]'),
        // Cached dimensions
        height   : 0,
        top      : 0
      });
    });
  }

  function refreshDimensions() {
    variants.forEach(function (v) {
      var rect = v.variant.getBoundingClientRect();
      v.height = v.variant.offsetHeight;
      v.top    = rect.top + window.scrollY;
    });
  }

  // Scroll progress through this variant: 0 = just entered, 1 = fully scrolled past
  function getProgress(v) {
    var scrollRange = v.height - window.innerHeight;
    if (scrollRange <= 0) return 0;
    return clamp((window.scrollY - v.top) / scrollRange, 0, 1);
  }

  function applyParallax() {
    if (prefersReduced || isMobileLayout()) return;

    variants.forEach(function (v) {
      var p  = getProgress(v);
      var pe = easeOut(p);

      // ── Layer 0: background letter — slow vertical drift ──
      if (v.letter) {
        v.letter.style.transform = 'translateY(' + lerp(60, -80, pe) + 'px)';
      }

      // ── Layer 1: image column wrapper — no additional transform needed;
      //    the inner image handles all motion. Keep stub in case of fallback. ──

      // ── Image diagonal zoom-reveal ────────────────────────────────────
      // The column has overflow:hidden — it clips everything outside its bounds.
      // Phase 1 (p 0→0.30): image enters from bottom-right corner diagonally,
      //   simultaneously zooming out from scale(1.18) to scale(1.0).
      //   Both X and Y offsets collapse to zero — a true diagonal wipe.
      // Phase 2 (p 0.30→1.0): image gently continues drifting diagonally
      //   upward-left, deepening the parallax sense of depth.
      if (v.imgInner) {
        // Phase 1 — entry (diagonal zoom-reveal)
        var pi  = clamp(p / 0.30, 0, 1);
        var epi = easeOutQuart(pi);

        var scaleVal = lerp(1.18, 1.0, epi);   // zoom out
        var entryX   = lerp(55,   0,   epi);   // slide in from right
        var entryY   = lerp(65,   0,   epi);   // rise from below

        // Phase 2 — post-reveal diagonal drift (subtle continued parallax)
        var postReveal = clamp((p - 0.30) / 0.70, 0, 1);
        var epPost     = easeOut(postReveal);
        var driftX     = lerp(0, -14, epPost); // drift left
        var driftY     = lerp(0, -22, epPost); // drift up

        v.imgInner.style.transform =
          'translateX(' + (entryX + driftX) + 'px) ' +
          'translateY(' + (entryY + driftY) + 'px) ' +
          'scale(' + scaleVal + ')';
      }
      // ──────────────────────────────────────────────────────────────────

      // ── Layer 1a: coming-soon badge — slight counter-drift ──
      if (v.priceBdg) {
        v.priceBdg.style.transform = 'translateY(' + lerp(-8, 12, pe) + 'px)';
      }

      // ── Layer 2: meta + name — slide in from right, early ──
      var p2  = clamp(p / 0.18, 0, 1);
      var ep2 = easeOut(p2);
      v.name.forEach(function (el) {
        el.style.transform = 'translateX(' + lerp(72, 0, ep2) + 'px)';
        el.style.opacity   = lerp(0, 1, ep2);
      });

      // ── Layer 3: highlight + short + story — delayed entry ──
      var p3  = clamp((p - 0.04) / 0.22, 0, 1);
      var ep3 = easeOut(p3);
      v.l3.forEach(function (el) {
        el.style.transform = 'translateX(' + lerp(88, 0, ep3) + 'px)';
        el.style.opacity   = lerp(0, 1, ep3);
      });

      // ── Layer 4: notes + CTA — most delayed entry ──
      var p4  = clamp((p - 0.09) / 0.22, 0, 1);
      var ep4 = easeOut(p4);
      v.l4.forEach(function (el) {
        el.style.transform = 'translateX(' + lerp(100, 0, ep4) + 'px)';
        el.style.opacity   = lerp(0, 1, ep4);
      });
    });
  }

  // Set initial parked state — prevents flash of settled content before JS runs
  function setInitialState() {
    if (prefersReduced || isMobileLayout()) return;
    variants.forEach(function (v) {
      // Image starts enlarged and offset to bottom-right (diagonal entry start)
      if (v.imgInner) {
        v.imgInner.style.transform = 'translateX(55px) translateY(65px) scale(1.18)';
      }
      v.name.forEach(function (el) {
        el.style.transform = 'translateX(72px)';
        el.style.opacity   = '0';
      });
      v.l3.forEach(function (el) {
        el.style.transform = 'translateX(88px)';
        el.style.opacity   = '0';
      });
      v.l4.forEach(function (el) {
        el.style.transform = 'translateX(100px)';
        el.style.opacity   = '0';
      });
    });
  }

  // ── Mobile entrance animations (IntersectionObserver) ────────────────
  // Triggered when each variant scrolls into view. Uses CSS transitions
  // rather than scroll-driven rAF, which is more appropriate for the
  // stacked single-column mobile layout.
  function initMobileAnimations() {
    if (prefersReduced) return;
    if (!('IntersectionObserver' in window)) return;

    variants.forEach(function (v) {
      // ── Set initial parked state ──
      if (v.imgInner) {
        v.imgInner.classList.add('fc-mob-hidden-img', 'fc-mob-anim-img');
      }

      // Collect all content layer elements in order (for stagger)
      var textEls = Array.prototype.slice.call(v.name)
        .concat(Array.prototype.slice.call(v.l3))
        .concat(Array.prototype.slice.call(v.l4));

      textEls.forEach(function (el) {
        el.classList.add('fc-mob-hidden-text', 'fc-mob-anim-text');
      });

      // ── Observe the variant entering the viewport ──
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          // Image: remove hidden class so transition resolves to natural state
          if (v.imgInner) {
            // Tiny delay so the browser registers the start state first
            setTimeout(function () {
              v.imgInner.classList.remove('fc-mob-hidden-img');
            }, 30);
          }

          // Text: staggered release
          textEls.forEach(function (el, i) {
            setTimeout(function () {
              el.classList.remove('fc-mob-hidden-text');
            }, 160 + i * 75);
          });

          observer.disconnect();
        });
      }, { threshold: 0.12 });

      observer.observe(v.variant);
    });
  }

  // RAF-throttled scroll handler
  var rafPending = false;
  function onScroll() {
    if (!rafPending) {
      rafPending = true;
      requestAnimationFrame(function () {
        applyParallax();
        rafPending = false;
      });
    }
  }

  // Debounced resize
  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      refreshDimensions();
      applyParallax();
    }, 120);
  }

  function init() {
    collectVariants();
    if (!variants.length) return;

    if (isMobileLayout()) {
      // Mobile: CSS-transition entrance animations via IntersectionObserver
      initMobileAnimations();
    } else {
      // Desktop: scroll-driven parallax
      refreshDimensions();
      setInitialState();
      applyParallax();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ─────────────────────────────────────────────────────────────
   TESTIMONIALS CAROUSEL
   • Staggered vertical exit-then-entry fade
   • Exit finishes before entry begins — no visual overlap
   • Self-rescheduling setTimeout auto-advance (immune to drift)
   • Prev / next arrows + dot indicators + swipe + keyboard
   ───────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var section = document.querySelector('.testimonials');
  if (!section) return;

  var prevBtn = section.querySelector('.test-arrow--prev');
  var nextBtn = section.querySelector('.test-arrow--next');
  var dots    = Array.prototype.slice.call(section.querySelectorAll('.test-dot'));
  var slides  = Array.prototype.slice.call(section.querySelectorAll('.test-slide'));

  if (!slides.length) return;

  var current     = 0;
  var total       = slides.length;
  var autoplay    = section.dataset.testAutoplay !== 'false';
  var interval    = parseInt(section.dataset.testInterval, 10) || 5500;
  var isAnimating = false;
  var paused      = false;
  var timer       = null;

  // Timing: exit fades out in 500ms, entry fades in over 700ms (overlap is fine for pure fades)
  var EXIT_DURATION  = 500;
  var ENTRY_DELAY    = 0;
  var ENTRY_DURATION = 700;
  var TOTAL_ANIM     = ENTRY_DURATION + 80;

  // ── Dot / aria helpers ───────────────────────────────────
  function updateDots(idx) {
    dots.forEach(function (d, i) {
      d.classList.toggle('test-dot--active', i === idx);
      d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
    });
    slides.forEach(function (s, i) {
      s.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
    });
  }

  // ── Core transition: staggered exit → entry ─────────────
  function goTo(nextIdx) {
    if (isAnimating || nextIdx === current) return;
    isAnimating = true;

    var outSlide = slides[current];
    var inSlide  = slides[nextIdx];

    updateDots(nextIdx);

    // ── Phase 1: start exit ──────────────────────────────
    outSlide.classList.add('test-slide--exit');
    outSlide.classList.remove('test-slide--active');

    // ── Phase 2 & 3: fade in the incoming slide ───────────
    // All slides are position:absolute always — no layout shift possible.
    inSlide.classList.add('test-slide--active');

    // ── Phase 4: cleanup after fade completes ─────────────
    setTimeout(function () {
      outSlide.classList.remove('test-slide--exit');
      current     = nextIdx;
      isAnimating = false;

      // Schedule next advance only AFTER animation fully completes
      if (autoplay && !paused && total > 1) {
        timer = setTimeout(autoAdvance, interval);
      }
    }, TOTAL_ANIM);
  }

  function advance(dir) { goTo(((current + dir) % total + total) % total); }

  // ── Auto-advance ─────────────────────────────────────────
  function autoAdvance() {
    if (!paused) { goTo((current + 1) % total); }
    // Note: next timer is set inside the goTo cleanup callback
  }

  function startAutoplay() {
    if (!autoplay || total <= 1) return;
    clearTimeout(timer);
    // Only schedule if not currently animating (goTo reschedules itself)
    if (!isAnimating) {
      timer = setTimeout(autoAdvance, interval);
    }
  }

  function stopAutoplay() {
    paused = true;
    clearTimeout(timer);
  }

  function resumeAutoplay() {
    paused = false;
    startAutoplay();
  }

  // ── Hover / focus pause ───────────────────────────────────
  section.addEventListener('mouseenter', stopAutoplay);
  section.addEventListener('mouseleave', resumeAutoplay);
  section.addEventListener('focusin',    stopAutoplay);
  section.addEventListener('focusout',   resumeAutoplay);

  // ── Manual controls ──────────────────────────────────────
  if (prevBtn) prevBtn.addEventListener('click', function () {
    stopAutoplay();
    advance(-1);
    // Resume after manual navigation (slight delay feels more natural)
    setTimeout(resumeAutoplay, 200);
  });
  if (nextBtn) nextBtn.addEventListener('click', function () {
    stopAutoplay();
    advance(+1);
    setTimeout(resumeAutoplay, 200);
  });

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      stopAutoplay();
      goTo(i);
      setTimeout(resumeAutoplay, 200);
    });
    dot.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); stopAutoplay(); advance(+1); setTimeout(resumeAutoplay, 200); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); stopAutoplay(); advance(-1); setTimeout(resumeAutoplay, 200); }
    });
  });

  // ── Swipe ────────────────────────────────────────────────
  var touchStartX = 0;
  section.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].clientX;
  }, { passive: true });
  section.addEventListener('touchend', function (e) {
    var delta = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(delta) > 44) {
      stopAutoplay();
      advance(delta < 0 ? +1 : -1);
      setTimeout(resumeAutoplay, 200);
    }
  }, { passive: true });

  // ── Keyboard ─────────────────────────────────────────────
  section.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); stopAutoplay(); advance(+1); setTimeout(resumeAutoplay, 200); }
    if (e.key === 'ArrowLeft')  { e.preventDefault(); stopAutoplay(); advance(-1); setTimeout(resumeAutoplay, 200); }
  });

  // ── Boot ─────────────────────────────────────────────────
  startAutoplay();
})();


/* ─────────────────────────────────────────────────────────────
   CUSTOM CURSOR  (.is-dark / .is-hover / .is-product / .is-hidden)
   ───────────────────────────────────────────────────────────── */
(function() {
  if (isTouch()) return;
  var dot  = document.getElementById('cursorDot');
  var ring = document.getElementById('cursorRing');
  if (!dot || !ring) return;

  var mx = -200, my = -200, rx = -200, ry = -200;
  var ringRafActive = false;

  // Self-stopping lerp loop — only runs while the ring is catching up.
  // Restarts on the next mousemove, keeping CPU idle between movements.
  function scheduleRingUpdate() {
    if (ringRafActive) return;
    ringRafActive = true;
    (function rf() {
      rx = lerp(rx, mx, 0.14);
      ry = lerp(ry, my, 0.14);
      ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px) translate(-50%,-50%)';
      if (Math.abs(rx - mx) > 0.1 || Math.abs(ry - my) > 0.1) {
        requestAnimationFrame(rf);
      } else {
        ringRafActive = false;
      }
    })();
  }

  document.addEventListener('mousemove', function(e) {
    mx = e.clientX; my = e.clientY;
    dot.style.transform = 'translate(' + mx + 'px,' + my + 'px) translate(-50%,-50%)';
    dot.classList.remove('is-hidden');
    ring.classList.remove('is-hidden');
    scheduleRingUpdate();
  });

  document.addEventListener('mouseleave', function() {
    dot.classList.add('is-hidden');
    ring.classList.add('is-hidden');
  });

  // Dark section + product detection via mouseover (fires on element entry, not
  // per pixel — avoids the expensive elementFromPoint() call on every mousemove).
  var hoverSel = 'a,button,.size-btn,.wish-size-btn,.color-swatch,.filter-btn,.coll-size-btn,.coll-atb-btn,.coll-wish-btn,.coll-view-link,.coll-notify-link,.nav-account';
  document.addEventListener('mouseover', function(e) {
    var el        = e.target;
    var inDark    = !!el.closest('[data-dark="true"]');
    var onProduct = !!el.closest('[data-cursor="product"]');
    dot.classList.toggle('is-dark',    inDark);
    ring.classList.toggle('is-dark',   inDark);
    dot.classList.toggle('is-product',  onProduct);
    ring.classList.toggle('is-product', onProduct);
    if (el.closest(hoverSel)) {
      dot.classList.add('is-hover');
      ring.classList.add('is-hover');
    }
  });
  document.addEventListener('mouseout', function(e) {
    if (e.target.closest(hoverSel)) {
      dot.classList.remove('is-hover');
      ring.classList.remove('is-hover');
    }
  });
})();


/* ─────────────────────────────────────────────────────────────
   ANNOUNCEMENT BANNER
   ───────────────────────────────────────────────────────────── */
(function() {
  var banner = document.getElementById('announcement-banner');
  if (!banner) return;
  var BKEY = 'edl_banner_v2';
  if (localStorage.getItem(BKEY)) {
    banner.style.display = 'none';
    document.documentElement.style.setProperty('--banner-h', '0rem');
    return;
  }
  var closeBtn = document.getElementById('announceBtnClose');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      banner.classList.add('dismissed');
      document.documentElement.style.setProperty('--banner-h', '0rem');
      setTimeout(function() { banner.style.display = 'none'; }, 440);
      localStorage.setItem(BKEY, '1');
    });
  }
})();


/* ─────────────────────────────────────────────────────────────
   NAV — scroll behaviour (transparent → frosted)
   ───────────────────────────────────────────────────────────── */
(function() {
  var nav = document.querySelector('.nav');
  if (!nav) return;
  // Pages with always-frosted nav don't need scroll handler
  if (nav.classList.contains('nav--always-frosted')) return;

  function onScroll() {
    if (window.scrollY > 60) {
      nav.classList.add('scrolled');
      nav.classList.remove('nav--transparent', 'nav--dark');
    } else {
      nav.classList.remove('scrolled');
      if (nav.dataset.heroPage) {
        nav.classList.add('nav--transparent');
        // Only restore dark text/icons if the hero has a dark background
        // (controlled by Header → "Hero has dark background" setting)
        if (nav.dataset.darkHero) nav.classList.add('nav--dark');
      }
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();


/* ─────────────────────────────────────────────────────────────
   HAMBURGER / MOBILE NAV
   ───────────────────────────────────────────────────────────── */
(function() {
  var hamburger = document.getElementById('navHamburger');
  var mobileNav = document.getElementById('mobileNav');
  if (!hamburger || !mobileNav) return;

  function close() {
    mobileNav.classList.remove('open');
    hamburger.classList.remove('open');
    hamburger.setAttribute('aria-expanded', 'false');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  hamburger.addEventListener('click', function() {
    var isOpen = mobileNav.classList.toggle('open');
    hamburger.classList.toggle('open', isOpen);
    hamburger.setAttribute('aria-expanded', String(isOpen));
    mobileNav.setAttribute('aria-hidden', String(!isOpen));
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });

  mobileNav.querySelectorAll('a').forEach(function(a) { a.addEventListener('click', close); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });
})();


/* ─────────────────────────────────────────────────────────────
   CART — Shopify AJAX cart integration
   ───────────────────────────────────────────────────────────── */
EDL.Cart = (function() {
  var cartDrawer  = document.getElementById('cartDrawer');
  var cartOverlay = document.getElementById('cartOverlay');

  function open() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    renderCart();
  }

  function close() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function updateBadge(count) {
    var badge = document.getElementById('navCartBadge');
    if (!badge) return;
    badge.textContent = count > 99 ? '99+' : count;
    badge.classList.toggle('visible', count > 0);
  }

  function updateWishBadge() {
    var badge = document.getElementById('navWishBadge');
    if (!badge) return;
    var stored = localStorage.getItem('edl_wishlist_v1');
    var items = stored ? JSON.parse(stored) : [];
    badge.textContent = items.length;
    badge.classList.toggle('visible', items.length > 0);
  }

  function renderCart() {
    var body   = document.getElementById('cartBody');
    var footer = document.getElementById('cartFooter');
    var cntEl  = document.getElementById('cartItemCount');
    var subEl  = document.getElementById('cartSubtotal');
    if (!body) return;

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var qty = cart.item_count;
        if (cntEl) cntEl.textContent = qty === 1 ? '1 item' : qty + ' items';
        updateBadge(qty);

        if (qty === 0) {
          if (footer) footer.style.display = 'none';
          body.innerHTML = '<div class="cart-empty">' +
            '<svg class="cart-empty-icon" width="48" height="56" viewBox="0 0 20 22" fill="none" stroke="rgba(232,225,214,0.45)" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M6.5 8.5V6.2C6.5 4.1 8.07 2.5 10 2.5s3.5 1.6 3.5 3.7v2.3"/>' +
            '<rect x="2" y="8.5" width="16" height="12" rx="1.2"/></svg>' +
            '<p class="cart-empty-title">Your bag is empty.</p>' +
            '<p class="cart-empty-sub">Nothing lingers here yet.</p>' +
            '<a href="/collections/all" class="cart-empty-cta">Explore the Collection</a>' +
            '</div>';
          return;
        }

        if (footer) footer.style.display = 'block';
        if (subEl) subEl.textContent = Shopify.formatMoney(cart.total_price);

        body.innerHTML = cart.items.map(function(item) {
          return '<div class="cart-item">' +
            '<div class="cart-item-swatch">' +
            (item.image ? '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' :
              '<svg viewBox="0 0 60 75" fill="none" width="40" height="50"><path d="M18 15 L5 26 L13 30 L13 68 L47 68 L47 30 L55 26 L42 15 L37 19 Q30 23 23 19 Z" stroke="rgba(232,225,214,0.3)" stroke-width="0.8" fill="rgba(232,225,214,0.06)"/></svg>') +
            '</div>' +
            '<div class="cart-item-info">' +
            '<span class="cart-item-name">' + item.product_title + '</span>' +
            '<div class="cart-item-meta">' + (item.variant_title !== 'Default Title' ? item.variant_title : '') + '</div>' +
            '<div class="cart-qty-control">' +
            '<button class="cart-qty-btn" data-key="' + item.key + '" data-change="-1" aria-label="Decrease quantity">−</button>' +
            '<span class="cart-qty-num">' + item.quantity + '</span>' +
            '<button class="cart-qty-btn" data-key="' + item.key + '" data-change="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '</div>' +
            '<div class="cart-item-right">' +
            '<span class="cart-item-price">' + Shopify.formatMoney(item.line_price) + '</span>' +
            '<button class="cart-item-remove" data-key="' + item.key + '">Remove</button>' +
            '</div>' +
            '</div>';
        }).join('');

        // Bind qty/remove buttons
        body.querySelectorAll('.cart-qty-btn').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var numEl = btn.parentNode.querySelector('.cart-qty-num');
            var currentQty = numEl ? parseInt(numEl.textContent) : 1;
            var newQty = Math.max(0, currentQty + parseInt(btn.dataset.change));
            changeCartQty(btn.dataset.key, newQty);
          });
        });
        body.querySelectorAll('.cart-item-remove').forEach(function(btn) {
          btn.addEventListener('click', function() {
            removeFromCart(btn.dataset.key);
          });
        });
      })
      .catch(function() {
        body.innerHTML = '<div class="cart-empty"><p class="cart-empty-title">Unable to load bag.</p></div>';
      });
  }

  function changeCartQty(key, newQty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    }).then(function() { renderCart(); });
  }

  function removeFromCart(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function() { renderCart(); });
  }

  function addToCart(variantId, quantity, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1, properties: properties || {} })
    }).then(function(r) {
      if (!r.ok) throw new Error('Add to cart failed');
      return r.json();
    }).then(function() {
      open();
    });
  }

  // Wire up cart trigger button
  document.addEventListener('DOMContentLoaded', function() {
    var trigger = document.getElementById('cartTrigger');
    if (trigger) trigger.addEventListener('click', open);

    var closeBtn = document.getElementById('cartClose');
    if (closeBtn) closeBtn.addEventListener('click', close);

    var continueBtn = document.getElementById('cartContinue');
    if (continueBtn) continueBtn.addEventListener('click', close);

    if (cartOverlay) cartOverlay.addEventListener('click', close);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('open')) close();
    });

    // Initialize badge on load
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateBadge(cart.item_count); });

    updateWishBadge();
  });

  return { open: open, close: close, addToCart: addToCart, updateBadge: updateBadge, updateWishBadge: updateWishBadge };
})();


/* ─────────────────────────────────────────────────────────────
   ACCORDION
   ───────────────────────────────────────────────────────────── */
(function() {
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.accordion-trigger');
    if (!trigger) return;
    var item  = trigger.closest('.accordion-item');
    var bodyId = 'acc-' + trigger.dataset.accordion;
    var body  = document.getElementById(bodyId) || item && item.querySelector('.accordion-body');
    if (!body) return;

    var isOpen = trigger.classList.contains('open');
    // Close siblings
    var accordion = trigger.closest('.details-accordion');
    if (accordion) {
      accordion.querySelectorAll('.accordion-trigger').forEach(function(t) { t.classList.remove('open'); });
      accordion.querySelectorAll('.accordion-body').forEach(function(b) { b.classList.remove('open'); });
    }
    if (!isOpen) {
      trigger.classList.add('open');
      body.classList.add('open');
    }
  });
})();


/* ─────────────────────────────────────────────────────────────
   SIZE GUIDE MODAL
   ───────────────────────────────────────────────────────────── */
(function() {
  var overlay = document.getElementById('sizeModalOverlay');
  if (!overlay) return;

  var closeBtn = document.getElementById('sizeModalClose');

  function open() {
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('#sizeGuideBtn') || e.target.closest('.size-guide-link')) {
      e.preventDefault();
      open();
    }
  });

  if (closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) close(); });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('open')) close();
  });

  // Highlight selected size row in table
  document.querySelectorAll('.size-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var size = btn.dataset.size;
      overlay.querySelectorAll('tr[data-size]').forEach(function(row) {
        row.classList.toggle('is-selected', row.dataset.size === size);
      });
    });
  });
})();


/* ─────────────────────────────────────────────────────────────
   SIZE SELECTOR  (.size-btn.selected)
   ───────────────────────────────────────────────────────────── */
(function() {
  var grids = document.querySelectorAll('.size-grid');
  grids.forEach(function(grid) {
    grid.querySelectorAll('.size-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        grid.querySelectorAll('.size-btn').forEach(function(b) {
          b.classList.remove('selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('selected');
        btn.setAttribute('aria-pressed', 'true');
      });
    });
  });
})();


/* ─────────────────────────────────────────────────────────────
   ADD TO BAG — Product page (Shopify variant-based)
   ───────────────────────────────────────────────────────────── */
(function() {
  var addBtn = document.getElementById('addToBagBtn');
  if (!addBtn) return;

  addBtn.addEventListener('click', function() {
    /* If button is in "Notify Me" mode, let the modal handler take over */
    if (addBtn.dataset.notify === 'true') return;

    var variantId = addBtn.dataset.variantId;
    if (!variantId) return;

    var origText = addBtn.textContent;
    addBtn.textContent = 'Adding…';
    addBtn.disabled = true;

    EDL.Cart.addToCart(parseInt(variantId), 1)
      .then(function() {
        addBtn.textContent = 'Added ✓';
        addBtn.classList.add('added');
        setTimeout(function() {
          addBtn.textContent = origText;
          addBtn.classList.remove('added');
          addBtn.disabled = false;
        }, 2000);
      })
      .catch(function() {
        addBtn.textContent = 'Select a size';
        setTimeout(function() {
          addBtn.textContent = origText;
          addBtn.disabled = false;
        }, 2000);
      });
  });
})();


/* ─────────────────────────────────────────────────────────────
   PRODUCT VARIANT SELECTOR (size → variant ID mapping)
   ───────────────────────────────────────────────────────────── */
(function() {
  var variantSelect = document.querySelector('.product-variant-select');
  if (!variantSelect) return;

  var addBtn = document.getElementById('addToBagBtn');
  var priceEl = document.querySelector('.product-price-main');

  variantSelect.addEventListener('change', function() {
    var option = variantSelect.options[variantSelect.selectedIndex];
    if (!option) return;

    var price = option.dataset.price;
    if (priceEl && price) priceEl.textContent = Shopify.formatMoney(parseInt(price));

    if (addBtn) addBtn.dataset.variantId = option.value;

    // Update size button selection
    var size = option.dataset.size;
    if (size) {
      document.querySelectorAll('.size-btn').forEach(function(btn) {
        btn.classList.toggle('selected', btn.dataset.size === size);
        btn.setAttribute('aria-pressed', btn.dataset.size === size ? 'true' : 'false');
      });
    }
  });

  // Sync size buttons to variant select
  document.querySelectorAll('.size-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var size = btn.dataset.size;
      for (var i = 0; i < variantSelect.options.length; i++) {
        if (variantSelect.options[i].dataset.size === size) {
          variantSelect.selectedIndex = i;
          variantSelect.dispatchEvent(new Event('change'));
          break;
        }
      }
    });
  });
})();


/* ─────────────────────────────────────────────────────────────
   WISHLIST — localStorage-based
   ───────────────────────────────────────────────────────────── */
EDL.Wishlist = (function() {
  var KEY = 'edl_wishlist_v1';

  function get() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
  }
  function save(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    EDL.Cart.updateWishBadge();
  }
  function add(productId, variantId, title, price, image) {
    var list = get();
    var key = String(variantId || productId);
    if (!list.find(function(i) { return i.key === key; })) {
      list.push({ key: key, productId: productId, variantId: variantId, title: title, price: price, image: image });
      save(list);
    }
    return true;
  }
  function remove(key) {
    save(get().filter(function(i) { return i.key !== String(key); }));
  }
  function has(key) {
    return !!get().find(function(i) { return i.key === String(key); });
  }

  return { get: get, add: add, remove: remove, has: has };
})();


/* ─────────────────────────────────────────────────────────────
   WISHLIST BUTTON — Product page toggle
   ───────────────────────────────────────────────────────────── */
(function() {
  var btn = document.getElementById('wishlistBtn');
  if (!btn) return;

  var productId = btn.dataset.productId;
  var variantId = btn.dataset.variantId;
  var title     = btn.dataset.title;
  var price     = btn.dataset.price;
  var image     = btn.dataset.image;
  var key       = variantId || productId;

  function updateState() {
    var wishlisted = EDL.Wishlist.has(key);
    btn.classList.toggle('wishlisted', wishlisted);
    var labelEl = btn.querySelector('.wish-label');
    if (labelEl) labelEl.textContent = wishlisted ? 'Saved to Wishlist' : 'Save to Wishlist';
    var iconEl = btn.querySelector('.wish-icon');
    if (iconEl) iconEl.textContent = wishlisted ? '♥' : '♡';
  }

  btn.addEventListener('click', function() {
    if (EDL.Wishlist.has(key)) {
      EDL.Wishlist.remove(key);
    } else {
      EDL.Wishlist.add(productId, variantId, title, price, image);
    }
    updateState();
  });

  updateState();
})();


/* ─────────────────────────────────────────────────────────────
   PRODUCT GALLERY  (.gallery-slide.is-active / .gallery-thumb.is-active)
   Supports images, native Shopify videos, and external video embeds.
   Videos are played when their slide becomes active; paused on exit.
   ───────────────────────────────────────────────────────────── */
(function() {
  var slides = Array.from(document.querySelectorAll('.gallery-slide'));
  var thumbs = Array.from(document.querySelectorAll('.gallery-thumb'));
  if (!slides.length) return;

  var labels = ['Front', 'Back', 'Detail', 'Flat'];
  var current = 0;

  // ── Video helpers ──────────────────────────────────────────
  function getVideo(slide) {
    return slide.querySelector('video.gallery-video');
  }
  function playSlideVideo(slide) {
    var v = getVideo(slide);
    if (!v) return;
    v.muted = true;           // ensure muted (browser autoplay requirement)
    var p = v.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function() {   // autoplay blocked — show poster, no error thrown
        v.load();
      });
    }
  }
  function pauseSlideVideo(slide) {
    var v = getVideo(slide);
    if (v && !v.paused) v.pause();
  }

  function goTo(n) {
    pauseSlideVideo(slides[current]);
    slides[current].classList.remove('is-active');
    thumbs[current] && thumbs[current].classList.remove('is-active');

    current = ((n % slides.length) + slides.length) % slides.length;

    slides[current].classList.add('is-active');
    thumbs[current] && thumbs[current].classList.add('is-active');
    playSlideVideo(slides[current]);

    var lbl = document.getElementById('galleryLabel');
    var ctr = document.getElementById('galleryCounter');
    var mediaType = slides[current].dataset.mediaType;
    if (lbl) lbl.textContent = mediaType === 'video' || mediaType === 'external_video'
      ? 'Video' : (labels[current] || (current + 1));
    if (ctr) ctr.textContent = (current + 1) + ' / ' + slides.length;
  }

  // Autoplay the first slide if it's a video
  playSlideVideo(slides[0]);

  thumbs.forEach(function(thumb, i) {
    thumb.addEventListener('click', function() { goTo(i); });
  });
  var prevBtn = document.getElementById('galleryPrev');
  var nextBtn = document.getElementById('galleryNext');
  if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

  // Touch swipe
  var touchStart = 0;
  var galleryMain = document.getElementById('galleryMain');
  if (galleryMain) {
    galleryMain.addEventListener('touchstart', function(e) { touchStart = e.touches[0].clientX; }, { passive: true });
    galleryMain.addEventListener('touchend', function(e) {
      var diff = e.changedTouches[0].clientX - touchStart;
      if (Math.abs(diff) > 40) goTo(current + (diff < 0 ? 1 : -1));
    }, { passive: true });
  }

  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    var drawerOpen = document.getElementById('cartDrawer') && document.getElementById('cartDrawer').classList.contains('open');
    var modalOpen  = document.getElementById('sizeModalOverlay') && document.getElementById('sizeModalOverlay').classList.contains('open');
    if (drawerOpen || modalOpen) return;
    if (e.key === 'ArrowLeft')  goTo(current - 1);
    if (e.key === 'ArrowRight') goTo(current + 1);
  });
})();


/* ─────────────────────────────────────────────────────────────
   MANIFESTO MARQUEE — pause on hover
   ───────────────────────────────────────────────────────────── */
(function() {
  var track = document.querySelector('.manifesto-track');
  if (!track) return;
  track.addEventListener('mouseenter', function() { track.style.animationPlayState = 'paused'; });
  track.addEventListener('mouseleave', function() { track.style.animationPlayState = 'running'; });
})();


/* ─────────────────────────────────────────────────────────────
   NEWSLETTER FORM
   ───────────────────────────────────────────────────────────── */
(function() {
  var forms = document.querySelectorAll('.newsletter-form');
  forms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var input = form.querySelector('.newsletter-input');
      var success = form.parentElement && form.parentElement.querySelector('.newsletter-success');
      if (!input || !input.value.includes('@')) return;
      form.style.display = 'none';
      if (success) success.style.display = 'block';
    });
  });
})();


/* ─────────────────────────────────────────────────────────────
   CART PAGE (bag.html equivalent) — re-render on Shopify cart
   ───────────────────────────────────────────────────────────── */
(function() {
  var bagLayout = document.getElementById('bagLayout');
  if (!bagLayout) return;

  // The cart-main.liquid handles rendering on the server side.
  // JS handles qty +/- and remove interactions.
  //
  // HTML attribute names (cart-main.liquid):
  //   qty buttons  → data-dir="-1" / data-dir="1", data-key="{{ item.key }}"
  //   remove button → data-remove-key="{{ item.key }}"
  bagLayout.addEventListener('click', function(e) {

    // ── Qty +/- ─────────────────────────────────────────────
    var qtyBtn = e.target.closest('.bag-item-qty-btn');
    if (qtyBtn) {
      var key  = qtyBtn.dataset.key;
      var dir  = parseInt(qtyBtn.dataset.dir, 10) || 0;  // data-dir="-1" or "1"
      // Read current qty from the displayed span
      var bagItem   = qtyBtn.closest('.bag-item');
      var qtyEl     = bagItem ? bagItem.querySelector('.bag-item-qty-num') : null;
      var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      var newQty    = Math.max(0, currentQty + dir);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      }).then(function() { window.location.reload(); });
    }

    // ── Remove ──────────────────────────────────────────────
    var removeBtn = e.target.closest('.bag-item-remove');
    if (removeBtn) {
      // HTML uses data-remove-key (maps to dataset.removeKey)
      var removeKey = removeBtn.dataset.removeKey || removeBtn.dataset.key;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: removeKey, quantity: 0 })
      }).then(function() { window.location.reload(); });
    }

  });
})();


/* ─────────────────────────────────────────────────────────────
   WISHLIST PAGE — render from localStorage
   ───────────────────────────────────────────────────────────── */
(function() {
  var wishGrid = document.getElementById('wishGrid');
  if (!wishGrid) return;

  var countEl = document.getElementById('wishItemCount');

  function renderWishlist() {
    var items = EDL.Wishlist.get();
    if (countEl) countEl.textContent = items.length === 0 ? '—' : items.length === 1 ? '1 item' : items.length + ' items';

    if (items.length === 0) {
      wishGrid.innerHTML = '<div class="wish-empty">' +
        '<svg class="wish-empty-icon" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="rgba(11,26,43,0.28)" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
        '<p class="wish-empty-title">Nothing saved yet.</p>' +
        '<p class="wish-empty-sub">Add pieces from the Sillage Collection to build your wishlist.</p>' +
        '<a href="/collections/all" class="wish-empty-cta">Explore Collection</a>' +
        '</div>';
      return;
    }

    wishGrid.innerHTML = items.map(function(item, idx) {
      var productUrl = item.productId ? '/products/' + item.productId : '#';
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + (item.title || 'Product') + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;">'
        : '<div class="wish-card-placeholder" aria-hidden="true">' +
          '<svg viewBox="0 0 200 250" fill="none" width="90" height="110"><path d="M55 48 L14 82 L36 92 L36 220 L164 220 L164 92 L186 82 L145 48 L127 60 Q100 74 73 60 Z" stroke="rgba(11,26,43,0.18)" stroke-width="1.2" fill="rgba(255,255,255,0.6)"/></svg>' +
          '</div>';
      // productId stored as handle (used in URL); show size picker when it exists
      var hasHandle = !!(item.productId);
      return '<article class="wish-card" style="animation-delay:' + (idx * 0.07) + 's">' +
        // Remove button
        '<button class="wish-card-remove" data-key="' + item.key + '" aria-label="Remove ' + (item.title || 'item') + ' from wishlist">' +
        '<svg width="9" height="9" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><line x1="1" y1="1" x2="9" y2="9"/><line x1="9" y1="1" x2="1" y2="9"/></svg>' +
        '</button>' +
        // Image link
        '<a href="' + productUrl + '" class="wish-card-visual" tabindex="-1" aria-hidden="true">' +
        imgHtml +
        '</a>' +
        // Info
        '<div class="wish-card-info">' +
        '<a href="' + productUrl + '" class="wish-card-name">' + (item.title || 'Saved Piece') + '</a>' +
        '<p class="wish-card-note">Sillage Collection</p>' +
        '<p class="wish-card-price">' + (item.price || '—') + '</p>' +
        '</div>' +
        // Inline size picker (hidden until "Move to Bag" clicked)
        (hasHandle
          ? '<div class="wish-size-picker" id="wsp-' + item.key + '" hidden>' +
            '<span class="wish-size-picker-label">Select Size</span>' +
            '<div class="wish-sz-row"></div>' +
            '<button class="wish-sz-atb" type="button" disabled>Add to Bag</button>' +
            '</div>'
          : '') +
        // Actions
        '<div class="wish-card-actions">' +
        (hasHandle
          ? '<button class="wish-add-btn js-wish-move" type="button" data-key="' + item.key + '" data-handle="' + item.productId + '">Move to Bag</button>'
          : '<a href="' + productUrl + '" class="wish-add-btn wish-add-btn--view">View Product</a>') +
        '</div>' +
        '</article>';
    }).join('');

    // Bind remove buttons
    wishGrid.querySelectorAll('.wish-card-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        EDL.Wishlist.remove(btn.dataset.key);
        renderWishlist();
      });
    });

    // Bind "Move to Bag" buttons — fetch product variants, show inline size picker
    wishGrid.querySelectorAll('.js-wish-move').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key    = btn.dataset.key;
        var handle = btn.dataset.handle;
        var picker = document.getElementById('wsp-' + key);
        if (!picker) return;

        // Toggle closed if already open
        if (!picker.hidden) {
          picker.hidden = true;
          return;
        }

        var origText = btn.textContent;
        btn.textContent = 'Loading…';
        btn.disabled = true;

        fetch('/products/' + handle + '.js')
          .then(function(r) { return r.json(); })
          .then(function(product) {
            var szRow  = picker.querySelector('.wish-sz-row');
            var atbBtn = picker.querySelector('.wish-sz-atb');
            var selectedId = null;

            // Render size buttons
            szRow.innerHTML = product.variants.map(function(v) {
              return '<button class="wish-sz-btn' + (v.available ? '' : ' wish-sz-btn--sold') + '"' +
                (v.available ? '' : ' disabled') +
                ' data-vid="' + v.id + '">' + v.title + '</button>';
            }).join('');

            // Size selection
            szRow.querySelectorAll('.wish-sz-btn').forEach(function(szBtn) {
              szBtn.addEventListener('click', function() {
                szRow.querySelectorAll('.wish-sz-btn').forEach(function(b) { b.classList.remove('is-sel'); });
                szBtn.classList.add('is-sel');
                selectedId = parseInt(szBtn.dataset.vid);
                atbBtn.disabled = false;
              });
            });

            // Add to bag from picker — use onclick to avoid listener accumulation
            // on repeated open/close cycles
            atbBtn.onclick = function() {
              if (!selectedId) return;
              atbBtn.textContent = 'Adding…';
              atbBtn.disabled = true;
              EDL.Cart.addToCart(selectedId, 1).then(function() {
                atbBtn.textContent = 'Added ✓';
                btn.textContent = origText;
                btn.disabled = false;
                setTimeout(function() {
                  picker.hidden = true;
                  atbBtn.textContent = 'Add to Bag';
                  atbBtn.disabled = true;
                  szRow.querySelectorAll('.wish-sz-btn').forEach(function(b) { b.classList.remove('is-sel'); });
                  selectedId = null;
                }, 1800);
              }).catch(function() {
                atbBtn.textContent = 'Add to Bag';
                atbBtn.disabled = (selectedId == null);
              });
            };

            picker.hidden = false;
            btn.textContent = origText;
            btn.disabled = false;
          })
          .catch(function() {
            btn.textContent = origText;
            btn.disabled = false;
          });
      });
    });
  }

  renderWishlist();
})();


/* ─────────────────────────────────────────────────────────────
   COLLECTION HERO — cinematic reveal
   ───────────────────────────────────────────────────────────── */
(function() {
  var hero = document.getElementById('collectionHero');
  if (!hero) return;
  if (reducedMotion) { hero.classList.add('hero-revealed'); return; }
  // Let the page-loader lift first, then reveal
  var delay = 350;
  setTimeout(function() { hero.classList.add('hero-revealed'); }, delay);
  // Scroll indicator
  var scroll = document.getElementById('heroScroll');
  if (scroll) {
    setTimeout(function() { scroll.style.opacity = '1'; }, delay + 750);
  }
})();


/* ─────────────────────────────────────────────────────────────
   COLLECTION GRID — filter + quick-add
   ───────────────────────────────────────────────────────────── */
(function() {
  var filterBar = document.getElementById('collectionFilterBar');
  var grid      = document.getElementById('collectionGrid');
  if (!filterBar || !grid) return;

  // ── Filter buttons ──────────────────────────────────────
  var filterBtns  = filterBar.querySelectorAll('.filter-btn');
  var countEl     = document.getElementById('collectionCount');
  var isFiltering = false;

  var EXIT_MS    = 320;   // fade-out duration
  var ENTER_MS   = 560;   // fade-in duration
  var STAGGER_MS = 65;    // delay between each item entering
  var EASE_OUT   = 'cubic-bezier(0.25,0.46,0.45,0.94)';
  var EASE_ENTER = 'cubic-bezier(0.16,1,0.3,1)'; // spring-ish

  function applyFilter(filter) {
    if (isFiltering) return;
    isFiltering = true;
    filterBar.classList.add('is-filtering');

    var items = Array.from(grid.querySelectorAll('.collection-item'));

    // ── Phase 1: Exit — fade & lift all visible items out ──────
    items.forEach(function(item) {
      if (item.classList.contains('coll-hidden')) return; // already invisible
      item.style.transition = 'opacity ' + EXIT_MS + 'ms ' + EASE_OUT + ', transform ' + EXIT_MS + 'ms ' + EASE_OUT;
      item.style.opacity    = '0';
      item.style.transform  = 'translateY(-8px) scale(0.97)';
      item.style.pointerEvents = 'none';
    });

    // ── Phase 2: Reflow — hide non-matching, reset matching ────
    setTimeout(function() {
      var matching = [];

      items.forEach(function(item) {
        var show = filter === 'all' || item.dataset.status === filter;
        if (!show) {
          item.classList.add('coll-hidden');
          // Reset so they enter cleanly next time
          item.style.transition = 'none';
          item.style.opacity    = '0';
          item.style.transform  = 'translateY(18px) scale(0.96)';
        } else {
          item.classList.remove('coll-hidden');
          item.style.transition = 'none';
          item.style.opacity    = '0';
          item.style.transform  = 'translateY(18px) scale(0.96)';
          matching.push(item);
        }
      });

      // Update count text immediately after reflow
      if (countEl) {
        countEl.textContent = matching.length + (matching.length === 1 ? ' piece' : ' pieces');
      }

      // ── Phase 3: Enter — stagger each matching item in ───────
      matching.forEach(function(item, i) {
        setTimeout(function() {
          item.style.transition = 'opacity ' + ENTER_MS + 'ms ' + EASE_ENTER + ', transform ' + ENTER_MS + 'ms ' + EASE_ENTER;
          item.style.opacity    = '1';
          item.style.transform  = 'translateY(0) scale(1)';
          item.style.pointerEvents = '';
        }, i * STAGGER_MS + 16); // +16ms rAF-like delay so transition applies
      });

      // Unlock once the last item has finished entering
      var unlockDelay = matching.length * STAGGER_MS + ENTER_MS + 80;
      setTimeout(function() {
        isFiltering = false;
        filterBar.classList.remove('is-filtering');
      }, unlockDelay);

    }, EXIT_MS + 30);
  }

  filterBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var filter = btn.dataset.filter;
      if (btn.classList.contains('active')) return; // already selected
      filterBtns.forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      applyFilter(filter);
    });
  });

  // ── Quick-add — size selection ───────────────────────────
  grid.addEventListener('click', function(e) {
    // Size button selection
    var sizeBtn = e.target.closest('.js-coll-size');
    if (sizeBtn) {
      e.preventDefault(); e.stopPropagation();
      var panel = sizeBtn.closest('.coll-quick-add');
      if (!panel) return;
      panel.querySelectorAll('.coll-size-btn').forEach(function(b) { b.classList.remove('is-active'); });
      sizeBtn.classList.add('is-active');
      var atbBtn = panel.querySelector('.coll-atb-btn');
      if (atbBtn) {
        atbBtn.disabled = false;
        atbBtn.dataset.selectedVariant = sizeBtn.dataset.variantId;
      }
      return;
    }

    // Add to bag
    var atbBtn = e.target.closest('.js-coll-atb');
    if (atbBtn && !atbBtn.disabled) {
      e.preventDefault(); e.stopPropagation();
      var variantId = parseInt(atbBtn.dataset.selectedVariant);
      if (!variantId) return;
      var origText = atbBtn.textContent;
      atbBtn.textContent = 'Adding…';
      atbBtn.disabled = true;
      EDL.Cart.addToCart(variantId, 1).then(function() {
        atbBtn.textContent = 'Added ✓';
        setTimeout(function() {
          atbBtn.textContent = origText;
          atbBtn.disabled = false;
        }, 1800);
      }).catch(function() {
        atbBtn.textContent = 'Error — try again';
        atbBtn.disabled = false;
      });
      return;
    }

    // Wishlist toggle
    var wishBtn = e.target.closest('.js-coll-wish');
    if (wishBtn) {
      e.preventDefault(); e.stopPropagation();
      var pid = wishBtn.dataset.productId;
      if (!pid) return;
      if (EDL.Wishlist.has(pid)) {
        EDL.Wishlist.remove(pid);
        wishBtn.classList.remove('wishlisted');
        wishBtn.setAttribute('aria-pressed', 'false');
      } else {
        // Pass full product data so wishlist page renders properly
        EDL.Wishlist.add(
          pid,
          wishBtn.dataset.variantId || '',
          wishBtn.dataset.title     || '',
          wishBtn.dataset.price     || '',
          wishBtn.dataset.image     || ''
        );
        wishBtn.classList.add('wishlisted');
        wishBtn.setAttribute('aria-pressed', 'true');
        // Spring scale feedback
        wishBtn.style.transform = 'scale(1.28)';
        setTimeout(function() { wishBtn.style.transform = ''; }, 350);
      }
      return;
    }
  });

  // ── Seed wishlist button states on load ─────────────────
  grid.querySelectorAll('.js-coll-wish').forEach(function(btn) {
    if (EDL.Wishlist.has(btn.dataset.productId)) {
      btn.classList.add('wishlisted');
      btn.setAttribute('aria-pressed', 'true');
    }
  });
})();


/* ─────────────────────────────────────────────────────────────
   FORM ANIMATIONS  (focus shake + submit feedback)
   ───────────────────────────────────────────────────────────── */
(function() {
  // Newsletter form — animate button on submit
  var nlForm = document.getElementById('newsletter-form');
  if (nlForm) {
    var nlInput = nlForm.querySelector('.newsletter-input');
    var nlBtn   = nlForm.querySelector('.newsletter-btn');

    nlForm.addEventListener('submit', function(e) {
      if (nlInput && !nlInput.value.trim()) {
        e.preventDefault();
        nlInput.classList.add('form-shake');
        setTimeout(function() { nlInput.classList.remove('form-shake'); }, 500);
        return;
      }
      if (nlBtn) {
        nlBtn.textContent = 'Sending…';
        nlBtn.style.opacity = '0.7';
      }
    });

    // Focus state: add class to freeze the hover-lift so the glass
    // doesn't shift position while the user is typing
    if (nlInput) {
      var nlSection = nlForm.closest('.newsletter') || nlForm;
      nlInput.addEventListener('focus', function() {
        nlSection.classList.add('nl-input-active');
      });
      nlInput.addEventListener('blur', function() {
        nlSection.classList.remove('nl-input-active');
      });
    }
  }

  // Cart promo input shake on empty submit
  document.addEventListener('click', function(e) {
    var promoBtn = e.target.closest('.cart-promo-btn');
    if (!promoBtn) return;
    var promoInput = promoBtn.previousElementSibling;
    if (promoInput && !promoInput.value.trim()) {
      promoInput.classList.add('form-shake');
      setTimeout(function() { promoInput.classList.remove('form-shake'); }, 500);
    }
  });
})();


/* Featured collection cards are now simple links — no quick-add overlay. */


/* ─────────────────────────────────────────────────────────────
   CURSOR TRAIL — champagne dust with comet thread
   A tapered bezier thread + scattered micro-particles that
   drift and fade, like fine gold dust disturbed by movement.
   Canvas floats ABOVE all section content (pointer-events:none)
   so it's always visible, whether over glass or imagery.
   ───────────────────────────────────────────────────────────── */
function createCursorTrail(el, r, g, b, options) {
  if (!el || reducedMotion || isTouch()) return;
  options = options || {};

  var THREAD_MAX  = options.threadMax  || 80;   /* path sample points kept  */
  var DUST_MAX    = options.dustMax    || 160;  /* max floating dust motes  */
  var SAMPLE_DIST = options.sampleDist || 2;    /* px between path samples  */
  var THREAD_PEAK = options.threadPeak || 0.52; /* max thread opacity       */
  var DUST_PEAK   = options.dustPeak   || 0.7;  /* max dust mote opacity    */
  var DUST_LIFE   = options.dustLife   || 110;  /* frames a mote lives      */
  var TIP_W       = options.tipWidth   || 2.2;  /* thread width at tip      */

  /* Canvas sits ABOVE all section content — z-index high, no pointer events */
  var canvas = document.createElement('canvas');
  canvas.setAttribute('aria-hidden', 'true');
  canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;' +
                         'pointer-events:none;z-index:100;display:block;';
  el.appendChild(canvas);                        /* append after all children */
  var ctx = canvas.getContext('2d');

  var W = 0, H = 0;
  function resize() {
    var rc = el.getBoundingClientRect();
    W = rc.width; H = rc.height;
    canvas.width  = Math.round(W * devicePixelRatio);
    canvas.height = Math.round(H * devicePixelRatio);
    ctx.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0);
  }
  resize();
  window.addEventListener('resize', function() { ctx.setTransform(1,0,0,1,0,0); resize(); }, { passive: true });

  var thread  = [];   /* { x, y } path samples, newest last */
  var dust    = [];   /* { x, y, vx, vy, age, r } motes    */
  var rafId   = null;
  var idle    = 0;    /* frames since last mousemove        */
  var prevX   = -999, prevY = -999;
  var rng     = 0;    /* cheap seeded pseudo-random state   */

  function rand() { rng = (rng * 1664525 + 1013904223) & 0xffffffff; return (rng >>> 0) / 0xffffffff; }

  /* Spawn a small cluster of dust motes near (x, y) */
  function spawnDust(x, y) {
    var count = 3 + (rand() * 3 | 0);
    for (var k = 0; k < count; k++) {
      var angle = rand() * Math.PI * 2;
      var speed = 0.15 + rand() * 0.55;
      var radius = 0.8 + rand() * 1.4;
      dust.push({
        x: x + (rand() - 0.5) * 14,
        y: y + (rand() - 0.5) * 14,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 0.15,  /* slight upward drift */
        age: 0,
        r: radius
      });
    }
    while (dust.length > DUST_MAX) dust.shift();
  }

  function draw() {
    ctx.clearRect(0, 0, W, H);
    idle++;

    /* ── 1. Dust motes ── */
    ctx.save();
    var di = 0;
    while (di < dust.length) {
      var m = dust[di];
      m.age++;
      if (m.age > DUST_LIFE) { dust.splice(di, 1); continue; }
      m.x += m.vx; m.y += m.vy;
      m.vy += 0.008;                           /* gentle gravity */

      var t = m.age / DUST_LIFE;
      /* Rise then fall: peaks at t=0.25, gone at t=1 */
      var alpha = DUST_PEAK * 4 * t * (1 - t) * (1 - t);
      ctx.globalAlpha = alpha;
      ctx.fillStyle   = 'rgb(' + r + ',' + g + ',' + b + ')';
      ctx.beginPath();
      ctx.arc(m.x, m.y, m.r, 0, Math.PI * 2);
      ctx.fill();
      di++;
    }
    ctx.restore();

    /* Keep ticking while dust remains */
    if (dust.length > 0) {
      rafId = requestAnimationFrame(draw);
    } else {
      rafId = null;
    }
  }

  function startLoop() {
    if (!rafId) rafId = requestAnimationFrame(draw);
  }

  el.addEventListener('mousemove', function(e) {
    var rc = el.getBoundingClientRect();
    var x  = e.clientX - rc.left;
    var y  = e.clientY - rc.top;
    var dx = x - prevX, dy = y - prevY;
    if (dx * dx + dy * dy >= SAMPLE_DIST * SAMPLE_DIST) {
      if (thread.length >= THREAD_MAX) thread.shift();
      thread.push({ x: x, y: y });
      spawnDust(x, y);
      prevX = x; prevY = y;
    }
    idle = 0;
    startLoop();
  }, { passive: true });

  /* Let dust and thread fade out naturally on leave */
  el.addEventListener('mouseleave', startLoop);
}


/* ─────────────────────────────────────────────────────────────
   NEWSLETTER — silk thread trail + radial glow spotlight
   ───────────────────────────────────────────────────────────── */
(function() {
  var nl = document.querySelector('.newsletter');
  if (!nl || reducedMotion || isTouch()) return;

  /* Champagne filament trail */
  createCursorTrail(nl, 201, 185, 154, { maxAlpha: 0.55, tipWidth: 1.6, tailWidth: 0.2, trailMax: 60 });

  /* Large radial spotlight via CSS custom property */
  var glowRaf = null, pendingX = 50, pendingY = 50;

  nl.addEventListener('mousemove', function(e) {
    var rc = nl.getBoundingClientRect();
    pendingX = ((e.clientX - rc.left) / rc.width)  * 100;
    pendingY = ((e.clientY - rc.top)  / rc.height) * 100;
    if (!glowRaf) {
      glowRaf = requestAnimationFrame(function() {
        nl.style.setProperty('--nl-x', pendingX.toFixed(1) + '%');
        nl.style.setProperty('--nl-y', pendingY.toFixed(1) + '%');
        glowRaf = null;
      });
    }
  }, { passive: true });

  nl.addEventListener('mouseenter', function() { nl.style.setProperty('--nl-glow', '1'); });
  nl.addEventListener('mouseleave', function() {
    nl.style.setProperty('--nl-glow', '0');
    if (glowRaf) { cancelAnimationFrame(glowRaf); glowRaf = null; }
  });
})();


/* ─────────────────────────────────────────────────────────────
   HERO — silk thread trail + radial glow spotlight
   ───────────────────────────────────────────────────────────── */
(function() {
  var hero = document.querySelector('.hero');
  if (!hero || reducedMotion || isTouch()) return;

  var hasMedia = hero.classList.contains('hero--has-media');
  /* Champagne on dark media hero; navy (very subtle) on light beige hero */
  if (hasMedia) {
    createCursorTrail(hero, 201, 185, 154, { maxAlpha: 0.45, tipWidth: 1.4, tailWidth: 0.15, trailMax: 55 });
  } else {
    createCursorTrail(hero, 11, 26, 43, { maxAlpha: 0.18, tipWidth: 1.0, tailWidth: 0.1, trailMax: 50 });
  }

  var glowRaf = null, pendingX = 50, pendingY = 50;

  hero.addEventListener('mousemove', function(e) {
    var rc = hero.getBoundingClientRect();
    pendingX = ((e.clientX - rc.left) / rc.width)  * 100;
    pendingY = ((e.clientY - rc.top)  / rc.height) * 100;
    if (!glowRaf) {
      glowRaf = requestAnimationFrame(function() {
        hero.style.setProperty('--hero-x', pendingX.toFixed(1) + '%');
        hero.style.setProperty('--hero-y', pendingY.toFixed(1) + '%');
        glowRaf = null;
      });
    }
  }, { passive: true });

  hero.addEventListener('mouseenter', function() { hero.style.setProperty('--hero-glow', '1'); });
  hero.addEventListener('mouseleave', function() {
    hero.style.setProperty('--hero-glow', '0');
    if (glowRaf) { cancelAnimationFrame(glowRaf); glowRaf = null; }
  });
})();

/* ─────────────────────────────────────────────────────────────
   NOTIFY ME MODAL
   • Logged-out  → shows email input, submits contact form
   • Logged-in   → shows pre-filled email, submits contact form
   Customer is tagged as notify-{product-handle} in Shopify
   ───────────────────────────────────────────────────────────── */
(function() {
  var modal    = document.getElementById('notifyModal');
  if (!modal) return;   /* modal must exist; everything else is optional */

  var overlay  = document.getElementById('notifyOverlay');
  var closeBtn = document.getElementById('notifyClose');
  var formWrap = document.getElementById('notifyFormWrap');
  var success  = document.getElementById('notifySuccess');
  var nameEl   = document.getElementById('notifyProductName');
  var tagInput = document.getElementById('notifyTag');
  var subjInput= document.getElementById('notifySubject');
  var bodyInput= document.getElementById('notifyBody');
  /* Resolve form lazily — id= on Shopify form tag may render differently */
  function getForm() {
    return document.getElementById('NotifyMeForm') ||
           document.querySelector('#notifyFormWrap form');
  }

  function openModal(productName, productHandle) {
    if (nameEl)    nameEl.textContent  = productName;
    if (tagInput)  tagInput.value      = 'notify-' + productHandle;
    if (subjInput) subjInput.value     = 'Notify Me: ' + productName;
    if (bodyInput) bodyInput.value     = 'Customer requested notification for: ' +
                                         productName + ' (' + productHandle + ').' +
                                         (window.EDLCustomer && window.EDLCustomer.loggedIn
                                           ? ' Customer email: ' + window.EDLCustomer.email
                                           : '');
    /* Reset state */
    if (formWrap) formWrap.hidden = false;
    if (success)  success.hidden  = true;

    modal.hidden = false;
    document.body.style.overflow = 'hidden';

    /* Focus first input or submit */
    var first = modal.querySelector('input[type="email"], button[type="submit"]');
    if (first) setTimeout(function() { first.focus(); }, 80);
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  /* ── Open on ANY [data-notify="true"] click anywhere in the page ── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-notify="true"]');
    if (!btn) return;
    e.preventDefault();
    openModal(
      btn.dataset.productName   || 'this product',
      btn.dataset.productHandle || 'product'
    );
  });

  /* Close on overlay / close button / Escape */
  if (overlay)  overlay.addEventListener('click', closeModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  /* Form submit via AJAX — resolve form at submit time */
  modal.addEventListener('submit', function(e) {
    var form = e.target.closest('form');
    if (!form) return;
    e.preventDefault();

    var submitBtn = form.querySelector('.notify-submit');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending…'; }

    var data = new FormData(form);
    var action = form.action || '/contact';

    fetch(action, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
    .then(function(res) {
      /* Shopify contact form returns redirect on success; treat any non-5xx as success */
      if (res.ok || res.status === 302) {
        if (formWrap) formWrap.hidden = true;
        if (success)  success.hidden  = false;

        var msg = document.getElementById('notifySuccessMsg');
        if (msg) {
          msg.textContent = window.EDLCustomer && window.EDLCustomer.loggedIn
            ? 'You\'re on the list. We\'ll notify you at ' + window.EDLCustomer.email + '.'
            : 'You\'re on the list. We\'ll be in touch.';
        }
        /* Auto-close after 3.5 s */
        setTimeout(closeModal, 3500);
      } else {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Notify Me'; }
      }
    })
    .catch(function() {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Notify Me'; }
    });
  });
})();
